import { SizeField } from '../fields/size';
import { OrderSliderField } from '../fields/order_slider';

export function MarketForm() {
  return (
    <>
      <SizeField />
      <OrderSliderField />
    </>
  );
}
